import { render, staticRenderFns } from "./IconServices.vue?vue&type=template&id=09f5a3a0&"
import script from "./IconServices.vue?vue&type=script&lang=js&"
export * from "./IconServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports